import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Wrapper } from './InputHelperLabel.styles.js';
import IconWrapper from '../../IconWrapper/IconWrapper.js';
import Typography from '../../Typography/Typography.js';
import COLORS from '../../../constants/colors.js';

const InputHelperLabel = forwardRef((props, ref) => {
    const { children, type, showIcon = true, id } = props;
    const getIconAccordingToType = () => {
        switch (type) {
            case "desc": {
                return {
                    textColor: COLORS.GREY_500,
                    icon: null,
                };
            }
            case "error":
                return {
                    textColor: COLORS.RED,
                    // icon: (
                    //     <ErrorInfoIcon
                    //         fill={COLORS.RED}
                    //         width={20}
                    //         height={20}
                    //     />
                    // ),
                    icon: null,
                };
        }
    };
    const { icon, textColor } = getIconAccordingToType();
    return (jsxs(Wrapper, Object.assign({ id: id }, { children: [showIcon && children && icon ? (jsx(IconWrapper, Object.assign({ width: 16, height: 16 }, { children: icon }))) : null, jsx(Typography, Object.assign({ size: "s", color: textColor }, { children: children }))] })));
});

export { InputHelperLabel as default };
//# sourceMappingURL=InputHelperLabel.js.map
